module.exports = { hondaData: [
  {
    key: '1',
    title: '2019 Honda Civic Sedan LX',
    year: '2019',
    make: 'Honda',
    model: 'Civic',
    bodyStyle: 'Sedan',
    trim: 'LX',
    transmission: 'CVT',
    drivetrain: '',
    subTitle: 'CVT',
    url: '/new-inventory/index.htm?year=2019&model=Civic&trim=LX',
    image: 'https://pictures.dealer.com/c/classichonda/1721/07e6cb9b7643fec278806a2abb9d07f0x.jpg',
    lifestyleImage: '',
    features: ['Honda Sensing',],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '97',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
      {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '217',
        downPmt: '0',
        term: '36',
        miles: '12',
        disclaimer: '$0 cash down, $0 security deposit, and $0 due at signing. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: '',
      }
    ],
  },
  {
    key: '2',
    title: '2019 Honda Civic Hatchback Sport Turbo CVT',
    year: '2019',
    make: 'Honda',
    model: 'Civic',
    bodyStyle: 'Hatchback',
    trim: 'Sport',
    transmission: 'CVT',
    drivetrain: '',
    subTitle: '',
    url: '/new-inventory/index.htm?year=2019&model=Civic&bodyStyle=Hatchback&trim=Sport',
    image: 'https://pictures.dealer.com/c/classichonda/0247/1d23b922c247ad068e023967a17963c4x.jpg',
    lifestyleImage: '',
    features: ['Honda Sensing',],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '134',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '244',
        downPmt: '0',
        term: '36',
        miles: '12',
        disclaimer: '',
      },
          {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: '',
      }
    ],
  },
    {
    key: '3',
    title: '2019 Honda CR-V EX Turbo',
    year: '2019',
    make: 'Honda',
    model: 'CR-V',
    bodyStyle: 'SUV',
    trim: 'EX',
    transmission: 'CVT',
    drivetrain: '2WD',
    subTitle: 'CVT 2WD Turbo',
    url: '/new-inventory/index.htm?year=2019&model=CR-V&trim=EX',
    image: 'https://pictures.dealer.com/c/classichonda/0153/aebe08fad32911ac3b8e80c8d6fb2f16x.jpg',
    lifestyleImage: '',
    features: ['Honda Sensing', 'Moon Roof', 'Fog Lights', 'Remote Start', 'Android Auto', 'Apple CarPlay', 'Blind Spot Monitor'],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '189',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '299',
        downPmt: '0',
        term: '36',
        miles: '12',
        disclaimer: '',
      },
          {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: '',
      }
    ],
  },
    {
    key: '4',
    title: '2019 Honda Accord Sedan LX',
    year: '2019',
    make: 'Honda',
    model: 'Accord',
    bodyStyle: 'Sedan',
    trim: 'LX',
    transmission: 'CVT',
    drivetrain: '',
    subTitle: 'CVT',
    url: '/new-inventory/index.htm?year=2019&model=Accord&trim=LX',
    image: 'https://pictures.dealer.com/c/classichonda/0499/111b7e53d660c4325f542fa29b4bf988x.jpg',
    lifestyleImage: '',
    features: ['Honda Sensing',],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '159',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '269',
        downPmt: '0',
        term: '36',
        miles: '12',
        disclaimer: '',
      },
      {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: '',
      }
    ],
  },
    {
    key: '5',
    title: '2019 Honda Fit Hatchback LX',
    year: '2019',
    make: 'Honda',
    model: 'Fit',
    bodyStyle: 'Hatchback',
    trim: 'LX',
    transmission: 'CVT',
    drivetrain: '',
    subTitle: 'CVT',
    url: '/new-inventory/index.htm?year=2019&model=Fit&trim=LX',
    image: 'https://pictures.dealer.com/c/classichonda/1467/66d5dfecf48fbdb9062796af04bb9a6ex.jpg',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '129',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '239',
        downPmt: '0',
        term: '36',
        miles: '12',
        disclaimer: '',
      },
          {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: '',
      }
    ],
  },
    {
    key: '6',
    title: '2019 Honda HR-V LX',
    year: '2019',
    make: 'Honda',
    model: 'HR-V',
    bodyStyle: 'SUV',
    trim: 'LX',
    transmission: 'CVT',
    drivetrain: '2WD',
    subTitle: 'CVT 2WD',
    url: '/new-inventory/index.htm?year=2019&model=HR-V&trim=LX',
    image: 'https://pictures.dealer.com/c/classichonda/1749/815f7e030c5b7aa50a01119d61e5cc95x.jpg',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '154',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '264',
        downPmt: '0',
        term: '36',
        miles: '12',
        disclaimer: '',
      },
          {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: '',
      }
    ],
  },
    {
    key: '7',
    title: '2019 Honda Pilot EX-L',
    year: '2019',
    make: 'Honda',
    model: 'Pilot',
    bodyStyle: 'SUV',
    trim: 'LX',
    transmission: 'CVT',
    drivetrain: '2WD',
    subTitle: 'CVT',
    url: '/new-inventory/index.htm?year=2019&model=Pilot&trim=LX',
    image: 'https://pictures.dealer.com/c/classichonda/0320/7b89f31c6c0b2051c1a0325c7f41397cx.jpg',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '299',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '414',
        downPmt: '0',
        term: '36',
        miles: '12',
        disclaimer: '',
      },
          {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: '',
      }
    ],
  },
  {
    key: '8',
    title: '2019 Honda Odyssey Van EX-L',
    year: '2019',
    make: 'Honda',
    model: 'Odyssey',
    bodyStyle: 'Van',
    trim: 'EX-L',
    transmission: 'CVT',
    drivetrain: '',
    subTitle: '',
    url: '/new-inventory/index.htm?year=2019&model=Odyssey&trim=EX-L',
    image: 'https://pictures.dealer.com/c/classichonda/1087/d879a4ba21c5cff4e1f364af702f7651x.jpg',
    lifestyleImage: '',
    features: ['Leather', 'Moonroof', 'Apple CarPlay', 'Android Auto',],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '315',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '429',
        downPmt: '0',
        term: '36',
        miles: '12',
        disclaimer: '',
      },
      {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: '',
      }
    ],
  },
  {
    key: '9',
    title: '2019 Honda Ridgeline RTL-E',
    year: '2019',
    make: 'Honda',
    model: 'Ridgeline',
    bodyStyle: 'Truck',
    trim: 'RTL-E',
    transmission: 'CVT',
    drivetrain: '',
    subTitle: 'Truck',
    url: '/new-inventory/index.htm?year=2019&model=Ridgelinet&trim=RTL-E',
    image: 'https://pictures.dealer.com/c/classichonda/1199/e08e4d1c3cadf53e2222784eac80a8a8x.jpg',
    lifestyleImage: '',
    features: ['Leather', 'Moonroof', 'AWD', 'In-Bed Trunk Cooler', 'Tow Hitch',],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '379',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '499',
        downPmt: '0',
        term: '39',
        miles: '12',
        disclaimer: '',
      },
      {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: '',
      }
    ],
  },
  {
    key: '10',
    title: '2019 Honda Passport Sport',
    year: '2019',
    make: 'Honda',
    model: 'Passport',
    bodyStyle: 'SUV',
    trim: 'Sport',
    transmission: 'CVT',
    drivetrain: '',
    subTitle: '2WD',
    url: '/new-inventory/index.htm?year=2019&model=Passportt&trim=Sport',
    image: 'https://pictures.dealer.com/c/classichonda/1864/ecd16a923dd9a5d14919b0cb5a0b7b98x.jpg',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Featured Lease Offer',
        lease: 'true',
        pmt: '299',
        downPmt: '$1,999',
        term: '36',
        miles: '12',
        disclaimer: 'Cash down plus 1st month payment, tax, tag, registration fee, and $799 dealer fee. Lease term 36 months, 12k miles/year.',
      },
          {
        type: 'TRUE Sign & Drive',
        lease: 'true',
        pmt: '409',
        downPmt: '0',
        term: '39',
        miles: '12',
        disclaimer: '',
      },
      {
        type: 'Featured Finance Offer',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: '',
      }
    ],
  },
  ]
}